import React, { useCallback, useMemo } from 'react'
import { MarkerF, CircleF } from '@react-google-maps/api'
import { LatLng } from '../../../types/geofence.type'

type CircleMapperProps = {
    center?: LatLng
    radius: number
    updatePoint?: (coordinate: LatLng) => void
    isEdit?: boolean
}
export const CircleMapper = (props: CircleMapperProps) => {
    const onDragMarker = useCallback(
        ({ latLng }: google.maps.MapMouseEvent) => {
            const latitude = latLng?.lat()
            const longitude = latLng?.lng()
            if (latitude && longitude) {
                props?.updatePoint?.({ latitude, longitude })
            }
        },
        [props?.center]
    )

    const markerCenter = useMemo(() => {
        if (props?.center) {
            return new google.maps.LatLng({
                lat: props?.center.latitude,
                lng: props?.center.longitude,
            })
        }
    }, [props?.center])

    if (props?.center) {
        const { radius } = props
        return (
            <>
                {props?.isEdit && markerCenter && (
                    <MarkerF
                        position={markerCenter}
                        draggable
                        onDrag={onDragMarker}
                    />
                )}
                <CircleF
                    options={{
                        fillColor: 'rgba(242, 100, 90,0.5)',
                        strokeColor: 'blue',
                        strokeWeight: 2,
                    }}
                    center={markerCenter}
                    radius={radius}
                />
            </>
        )
    } else {
        return <></>
    }
}
